// Shared, language-independent site data. Translatable copy lives in
// src/i18n/content.js instead.

export const ASSETS = {
  logo: "/assets/brand/logo-arroyo-systems.svg",
  hero: "https://arroyo-systems.com/assets/engineering/machined-component-hero.png",
  safetyFactor: "https://arroyo-systems.com/assets/engineering/safety-factor-component.png",
  safetyFactorLegend: "https://arroyo-systems.com/assets/engineering/safety-factor-legend.png",
  threeDConnexionLogo: "/assets/brand/3dconnexion-logo.png",
  autodeskFusionLogo: "/assets/brand/autodesk-fusion.png",
  autodeskNastranLogo: "/assets/brand/autodesk-inventor-nastran.png",
};

export const NAV_HREFS = {
  solutions: "/#products",
  process: "/#process",
  partners: "/#partners",
};

export const LINKEDIN_URL = "https://www.linkedin.com/company/arroyo-systems-eng/";
export const EMAIL = "contact@arroyo-systems.com";
